// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"73":"stps-ocupaciones","884":"am","916":"diarios"}[chunkId] || chunkId) + "." + {"73":"0b59ff30","629":"cd21e849","636":"e0b59052","884":"c7e38219","916":"6bbbb2dd"}[chunkId] + ".css";
};